import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
type CountdownProps = {
  size?: 'lg' | 'sm';
};
export function Countdown({
  size = 'lg'
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: 'hrs'
  }, {
    value: minutes,
    label: 'min'
  }, {
    value: seconds,
    label: 'sec'
  }];
  const isLarge = size === 'lg';
  return <div className="flex items-center justify-center gap-2 sm:gap-3" role="timer" aria-live="off" aria-label={`Offer ends in ${hours} hours ${minutes} minutes ${seconds} seconds`} data-id="element-114" data-mp="3c1cr8rv0g8qw">
      {units.map(unit => <div key={unit.label} className={`rounded-xl border border-field-line bg-field-card text-center tabular-nums text-willow ${isLarge ? 'min-w-[74px] px-4 py-3 sm:min-w-[92px] sm:px-6 sm:py-4' : 'min-w-[58px] px-3 py-2'}`} data-id="element-115" data-mp="3259gwyq093sv">
          <div className={`font-display font-extrabold leading-none ${isLarge ? 'text-3xl sm:text-5xl' : 'text-2xl'}`} data-id="element-116" data-mp="15an11mhtl1ud">
            {unit.value}
          </div>
          <div className={`mt-1 font-bold uppercase tracking-widest text-cream/60 ${isLarge ? 'text-[10px]' : 'text-[9px]'}`} data-id="element-117" data-mp="t123nhtc76zf">
            {unit.label}
          </div>
        </div>)}
    </div>;
}